module.exports = __webpack_public_path__ + "static/about-insta-2-c3c37b70d120aa16ca28a763d128045a.jpg";